module.exports = __webpack_public_path__ + "static/img/openOffice.405eac9e.png";